import { render, staticRenderFns } from "./creating-a-crime-scene-diagram.vue?vue&type=template&id=5b39e4b3&"
import script from "./creating-a-crime-scene-diagram.vue?vue&type=script&lang=js&"
export * from "./creating-a-crime-scene-diagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports